<div class="client-task-modal" [ngClass]="{ open: tracked_item != null }">
  <div class="client-task-modal-wrapper">
    <div
      (click)="dashboardStore.selectTrackedItem(null, null)"
      class="modal-close"
    >
      <i class="feather x"></i>
    </div>
    <div class="company-name-wrapper">
      <div class="company-name" (click)="openCompanyWorkspace()" style="cursor: pointer;">{{ company?.name }}</div>
    </div>
    <tracked-item-bubble
      id="bubble-{{ tracked_item.id }}"
      #bubble
      *ngIf="tracked_item != null"
      [tracked_item]="tracked_item"
      [user]="user"
      [conversation]="_conversation"
      [accounts]="accounts"
      [classes]="classes"
      [isDrawer]="true"
      [hasSelectableClass]="hasSelectableClass"
    ></tracked-item-bubble>

    <div><hr /></div>

    <div #commentsWrapper class="comments" *ngIf="tracked_item != null">
      <div class="comments-header">
        <i class="tio-comment_vs_outlined" style="vertical-align: -1px"></i>
        Comments ({{ getCommentCount() }})
      </div>
      <div class="comments-content">
        <div
          *ngFor="let message of tracked_item.comments"
          class="comment-bubble"
        >
          <message-bubble
            origin="client-task"
            is_comment="true"
            [message]="message"
            [user]="user"
          >
          </message-bubble>
        </div>
      </div>
      <div class="chat-input-wrapper">
        <textarea
          class="form-control chat-input"
          #input
          (keyup.enter)="
            send_comment(tracked_item.messageInput, tracked_item.id, input);
            (false)
          "
          [(ngModel)]="tracked_item.messageInput"
          rows="1"
          [disabled]="isSendingComment || tracked_item.satisfied == true"
          autosize
          placeholder="{{ tracked_item.satisfied == true ? 'Comments cannot be added to Closed tasks' : 'Type a comment...' }}"
        ></textarea>
        <i
          class="tio-send send animated infinite d-flex align-items-center top-0"
          (click)="
            send_comment(tracked_item.messageInput, tracked_item.id, input)
          "
        ></i>
      </div>
    </div>
  </div>
</div>

<ng-template #deleteTrackedItemConfirmation>
  <div class="modal-body rounded text-center">
    <div>
      <!-- Removing any user -->
      <h4>Are you sure?</h4>
      <p>
        Do you really want to delete this client task? This action cannot be
        undone.
      </p>
    </div>

    <!-- Hide the buttons in case of archiving (removing last user) -->
    <div class="row">
      <div class="col-6">
        <button
          type="button"
          class="btn btn-danger pull-left btn-block"
          (click)="confirmClientTaskRemoval(tracked_item)"
        >
          Remove
        </button>
      </div>
      <div class="col-6">
        <button
          type="button"
          class="btn btn-default pull-right btn-block"
          (click)="bsModalRef.hide()"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
